import React from "react";
import styles from "./SmallLoading.module.scss";

export interface SmallLoadingProps {
  color?: "light" | "dark";
}

export const SmallLoading: React.FC<SmallLoadingProps> = (props) => {
  return (
    <span
      className={`${styles.loader} ${
        props.color === "dark" ? styles.dark : ""
      }`}
    ></span>
  );
};
